import { DotLegalInfoDialog } from "@dotlegal/dotlegal-ui-components";
import { useToggleIsPublishedDialog } from "./ToggleFrameworkTemplateStatusDialog.hooks.ts";
import { Box } from "@mui/system";

export interface ToggleFrameworkTemplateStatusDialogProps {
    isPublished: boolean;
    templateId: string;
    templateName: string;
    onCloseDialog: () => void;
    onToggleSuccess?: () => void;
}

function ToggleFrameworkTemplateStatusDialog(props: ToggleFrameworkTemplateStatusDialogProps) {
    const { toggleIsPublished, isMutatingIsPublished } = useToggleIsPublishedDialog(props);

    return (
        <DotLegalInfoDialog
            header={`${props.isPublished ? "Deactivate" : "Activate"} framework?`}
            btnText={props.isPublished ? "Deactivate" : "Activate"}
            content={
                props.isPublished ? (
                    <>
                        Are you sure you want to deactivate{" "}
                        <Box component={"span"} fontWeight={700}>
                            {props.templateName}
                        </Box>
                        ? After deactivating the framework, it will no longer be visible to any users.
                    </>
                ) : (
                    <>
                        Are you sure you want to activate{" "}
                        <Box component={"span"} fontWeight={700}>
                            {props.templateName}
                        </Box>
                        ? Once activated, all users with the required plan will be able to access the framework.
                    </>
                )
            }
            onCloseDialog={props.onCloseDialog}
            onBtnClick={toggleIsPublished}
            inProgress={isMutatingIsPublished}
        />
    );
}

export default ToggleFrameworkTemplateStatusDialog;
